import React, { memo } from 'react';
import { useWindowDimensions, TouchableOpacity, View, StyleSheet, ScrollView } from 'react-native';
import ThemeProvider from '@voltmoney/theme';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, } from '@voltmoney/schema';
import { Typography } from "../typography/Typography";
import { Icon } from "../icon/Icon";
/**
 * Primary UI component for user interaction
 */
const VoltPartnerCard = ({ showPartner }) => {
    const BreakPoints = {
        WEB: 1024,
    };
    const { width } = useWindowDimensions();
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const borderRadiusMapping = theme.borderRadius;
    let Links;
    (function (Links) {
        Links["BAJAJ"] = "https://www.bajajfinserv.in/";
        Links["KFIN"] = "https://www.kfintech.com/";
        Links["CAMS"] = "https://www.camsonline.com/";
        Links["NSDL"] = "https://nsdl.co.in/";
        Links["CDSL"] = "https://www.cdslindia.com/";
    })(Links || (Links = {}));
    const styles = StyleSheet.create({
        divider1: {
            borderWidth: 1,
            borderColor: colorMapping[ColorTokens.Primary_10],
            height: 1,
            flex: 1,
            marginLeft: 5,
            paddingLeft: 16,
        },
        trustedPartnerContainer: {
            flexDirection: 'column',
            width: '100%',
            marginTop: 22,
        },
        trustedPartnerDivider: {
            flexDirection: 'row',
            alignItems: 'center',
            width: '100%',
        },
        partnerItem: {
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            width: 90,
            height: 36,
            marginRight: 16,
            backgroundColor: colorMapping[ColorTokens.Grey_Milk],
        },
        partnerItemWeb: {
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            width: 90,
            height: 36,
            marginRight: 16,
            backgroundColor: colorMapping[ColorTokens.Grey_Milk],
        }
    });
    return (React.createElement(View, { style: styles.trustedPartnerContainer },
        React.createElement(View, { style: styles.trustedPartnerDivider },
            React.createElement(Typography, { label: "Our trusted partners", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, lineHeight: 18, fontWeight: "400", color: ColorTokens.Grey_Charcoal }),
            React.createElement(View, { style: { width: 8 } }),
            React.createElement(View, { style: styles.divider1 })),
        React.createElement(View, { style: { height: 16 } }),
        React.createElement(ScrollView, { horizontal: true, showsVerticalScrollIndicator: false },
            React.createElement(TouchableOpacity, { onPress: () => window.open(Links.BAJAJ, '_blank') },
                React.createElement(View, { style: (width < BreakPoints.WEB) ? styles.partnerItem : styles.partnerItemWeb },
                    React.createElement(Icon, { name: IconTokens.Bajaj, size: IconSizeTokens.XXXXXXXL }))),
            React.createElement(TouchableOpacity, { onPress: () => window.open(Links.KFIN, '_blank') },
                React.createElement(View, { style: (width < BreakPoints.WEB) ? styles.partnerItem : styles.partnerItemWeb },
                    React.createElement(Icon, { name: IconTokens.Kfin, size: IconSizeTokens.XS }))),
            React.createElement(TouchableOpacity, { onPress: () => window.open(Links.CAMS, '_blank') },
                React.createElement(View, { style: (width < BreakPoints.WEB) ? styles.partnerItem : styles.partnerItemWeb },
                    React.createElement(Icon, { name: IconTokens.Cams, size: IconSizeTokens.XS }))))));
};
export default memo(VoltPartnerCard);
export { VoltPartnerCard };
